import { useStore } from "../../hooks/store";
import Styles from "./Form.module.css";
import CustomField from "../shared/CustomTextField";
import { Formik } from "formik";
import { Button, ListSubheader, MenuItem } from "@mui/material";
// import { postSchool } from "../../../utils/API/schoolMethods";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import moment from "moment-timezone";
import { drivingLesson, drivingLessonStatus } from "../../utils/config";
import {
  deleteLesson,
  postLesson,
  updateLesson,
} from "../../utils/API/schoolMethods";
import { useState } from "react";
import {
  postDrivingTime,
  updateDrivingTime,
} from "../../utils/API/userMethods";
export default function DrivingTimeForm() {
  const store = useStore();
  const { id, user_id, category_id, driving_time, categoryList } =
    store.form.dataToUpdate;

  const handleSubmit = (values, callBack) => {
    postDrivingTime(values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }
      callBack();
      store.setAlert(data, "error");
    });
  };

  const handleUpdate = (values, callBack) => {
    updateDrivingTime(values.id, values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }
      callBack();
      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = {} && { flexDirection: "row" };
  return (
    <Formik
      initialValues={{
        id: id || null,
        user_id: user_id,
        category_id: category_id || "",
        driving_time: driving_time || 0,
      }}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        id
          ? handleUpdate(values, setSubmitting)
          : handleSubmit(values, setSubmitting);

        // submitSchool(values);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        /* and other goodies */
      }) => (
        <>
          <p>Назначение часов практики</p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <CustomField
                  disabled={isSubmitting}
                  select
                  name="category_id"
                  label={"Категория"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.category_id}>
                  {categoryList.map((category) => (
                    <MenuItem value={Number(category.id)}>
                      {category.name}
                    </MenuItem>
                  ))}
                </CustomField>
                <CustomField
                  disabled={isSubmitting}
                  label={"Колл-во часов"}
                  name="driving_time"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.driving_time}
                />
              </div>
            </div>

            <div
              className="form_actions"
              style={{
                paddingLeft: "20px",
                paddingRight: "20px",
              }}>
              <Button variant="contained" onClick={handleSubmit}>
                Сохранить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
